import { ICommand, key } from 'core-ts-types';
import * as _4 from 'lodash';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { WildcardSlot } from '../../../global/builders/ap_generic_slot_builder';
import { INVALID_ID } from '../../../global/constants/ap_id_constants';
import { RouterHelper } from '../../../global/helpers/router_helper';
import { APComponentStateModel } from '../../../global/models/ap_component_state_model';
import { APCourseServant } from '../../../global/servants/ap_course_servant';

export class WildcardTile {
  private wildcard: WildcardSlot;
  private programSlotId: WildcardSlot['programSlot']['id'];
  private expanded: boolean = false;
  private showUnplanCourseButton: boolean = false;
  private theme: string;
  private type: string;
  private id: WildcardSlot['programSlot']['id'];
  private badgeType: string;
  private isEditable: boolean | string;
  private isLocked: boolean = false;
  private wildcardButtonText = 'Find a course';
  private showSwapFindButton = false;

  constructor(
    private ngAPComponentStateModel: APComponentStateModel,
    private $animate: any,
    private $timeout: ng.ITimeoutService,
    private showLargeCourseGroupCommand: ICommand,
    private clearLargeCourseGroupSearchResultCommand: ICommand,
    private routerHelper: RouterHelper,
    private removeCourseFromTermAndAddCourseGroupCommand: ICommand,
    private ngComponentCommunicatorService: CommunicatorService,
    private phxAxTitleAnnouncerDelegate: any
  ) {}

  getIconPosition() {
    return this.expanded ? '90' : '0';
  }

  $onChanges() {
    this.id = this.wildcard.programSlot.id;
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
    this.isLocked = _4.get(this.wildcard, 'isLockedByAdvisor', false);
    this.showSwapFindButton = !this.isLocked && !APCourseServant.isLockedByStatus(this.wildcard.status);
    this.showUnplanCourseButton = this.showSwapFindButton && !!this.wildcard.plannedCourse;
    this.programSlotId = this.wildcard.programSlot.id;
    this.theme = this.wildcard.disableSlot ? 'gray' : 'primary';
    this.badgeType = this.type && !!this.wildcard.plannedCourse ? this.type : 'placeholder';
    this.updateComponentState(
      this.programSlotId,
      _4.get(this.ngAPComponentStateModel, `wildcardToggle[${this.programSlotId}].opened`, false)
    );
    this.wildcardButtonText =
      this.wildcard.isPlanned && !!_4.get(this.wildcard, 'plannedCourse.id', false) ? 'Swap course' : 'Find a course';
  }

  get _hasRequisiteProblem() {
    return _4.get(this.wildcard, 'plannedCourse._hasRequisiteProblem', false);
  }

  unPlanCourse() {
    const plannedCourse = this.wildcard.plannedCourse;
    this.removeCourseFromTermAndAddCourseGroupCommand(
      this.wildcard.plannedCourse,
      this.wildcard.termId,
      this.wildcard.programSlot
    ).then(() => {
      this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
      this.phxAxTitleAnnouncerDelegate.announceChange(
        `${_4.get(plannedCourse, '_course._title')} removed from ${this.wildcard.title}`
      );
    });
  }

  toggleExpand() {
    if (this.wildcard.disableSlot) {
      return;
    }
    this.updateComponentState(this.programSlotId, !this.expanded);
  }

  updateComponentState(id: key, state: boolean) {
    this.ngAPComponentStateModel.wildcardToggle(id, state);
    this.expanded = state;
  }

  searchForCourse() {
    this.$animate.enabled(false);
    this.clearLargeCourseGroupSearchResultCommand().then(() => {
      this.showLargeCourseGroupCommand(this.wildcard).then(() => {
        this.$timeout(
          () =>
            this.routerHelper.findStateAndGo(`^.coursegroup`, {
              slotId: this.wildcard.programSlot.id,
              termId: this.wildcard.termId
            }),
          0
        );
      });
    });
  }
}

angular.module('capability-ng-academic-planner').component('wildcardTile', {
  templateUrl: 'capability-ng-academic-planner/src/global/components/wildcard_tile/wildcard_tile.html',
  bindings: {
    wildcard: '<',
    term: '<',
    type: '@',
    isEditable: '<?'
  },
  controller: WildcardTile,
  transclude: true
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/wildcard_tile/wildcard_tile.ts